

import FormButton from "@/components/main/buttons/FormButton";
import xxx from "@/assets/images/main/icons/xxx.png"
import cams from "@/assets/images/main/icons/cams.png"
import dating from "@/assets/images/main/icons/dating.png"
import social from "@/assets/images/main/icons/social.png"
import tinder from "@/assets/images/main/icons/tinder.png"

import VueCountryCode from "vue-country-code";

export default {
  name: 'Steps',
  components: { FormButton, VueCountryCode },

  data() {
    return {
      localPhoneNumber: '',
      localCountryCode: '',      
      selectedStep: 'Name',
      images: {
        xxx,
        cams,
        dating,
        social,
        tinder
      },       
    }
  },

  mounted() {

  },

  computed: {
    name: {
      get() {
        return this.$store.state.stepsUserModule.searchName
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', value )
      }
    },    

    email: {
      get() {
        return this.$store.state.stepsUserModule.searchEmail
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', value )
      }
    },

    identityAddress: {
      get() {
        return this.$store.state.stepsUserModule.searchAddress
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_ADDRESS', value )
      }
    },

    stateCode: {
      get() {
        return this.$store.state.stepsUserModule.searchState
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_STATE', value )
      }
    },

    identityPhone: {
      get() {
        return this.$store.state.stepsUserModule.searchPhone
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_PHONE', value )
      }
    },
    searchCountryCode: {
      get() {
        return this.$store.state.stepsUserModule.searchCountryCode
      },

      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_COUNTRY_CODE', value )
      }
    },

    defaultCountryCode() {
      return this.$store.state.stepsUserModule.searchCountryCode
    }

  },
  methods: {
    submit() {
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', this.name)
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', this.email)
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_STATE', this.stateCode)
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_ADDRESS', this.identityAddress)
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_PHONE', this.identityPhone)
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_CONTRY_CODE', this.searchCountryCode)
      
      const stepMappings = {
        "Name": { plan: 5, product: "DS", path: '/account/search-credits/' },
        "Phone": { plan: 8, product: "LL", path: '/account/listing-locator/' },
        "Address": { plan: 8, product: "LL", path: '/account/listing-locator/' },
        "Email": { plan: 8, product: "LL", path: '/account/listing-locator/' },
        "Tinder": { plan: 2, product: "TN", path: '/account/tinder-blaster-credits/' },
        "Dating": { plan: 5, product: "DS", path: '/account/search-credits/' },
        "Social": { plan: 5, product: "DS", path: '/account/search-credits/' },
        "Web": { plan: 17, product: "LC", path: '/account/search-credits/' },
        "Cams": { plan: 17, product: "XS", path: '/account/search-credits/' },
      };

      const selectedStepMapping = stepMappings[this.selectedStep] || { plan: 1, product: "FREE", path: '/auth/register' };
      const redirectPath = this.$store.state.userModule.isLogged ? selectedStepMapping.path : `/auth/register?plan=${selectedStepMapping.plan}&product=${selectedStepMapping.product}`;

      this.$router.push(redirectPath);
    },
    selectStep(step) {
      this.selectedStep = step;
    },
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    onSelectCountryCode(value) {
      this.$store.commit('stepsUserModule/SET_SEARCH_USER_COUNTRY_CODE', value.iso2 )
    }    
  }
}
